import React from 'react';
import { BookOpenIcon, CheckCircleIcon } from 'lucide-react';
export function ProductContents() {
  return <section className="bg-[#FDF8F0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-181">
      <div className="max-w-4xl mx-auto" data-id="element-182">
        <div className="text-center mb-12" data-id="element-183">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-4" data-id="element-184">
            Lo que recibes hoy
          </h2>
          <p className="text-[#3D2E1F] opacity-80" data-id="element-185">
            Todo lo que necesitas para transformar tus mañanas, en un formato
            fácil de leer.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-186">
          <div className="bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0] flex items-start gap-4" data-id="element-187">
            <BookOpenIcon className="w-8 h-8 text-[#B8A068] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-188" />
            <div data-id="element-189">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-190">
                Guía Paso a Paso
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-191">
                Instrucciones claras para el "Protocolo de Cama" de 5 minutos.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0] flex items-start gap-4" data-id="element-192">
            <CheckCircleIcon className="w-8 h-8 text-[#B8A068] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-193" />
            <div data-id="element-194">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-195">
                Lista de Verificación de Movilidad
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-196">
                Los 6 pasos exactos que debes seguir cada mañana.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0] flex items-start gap-4" data-id="element-197">
            <CheckCircleIcon className="w-8 h-8 text-[#B8A068] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-198" />
            <div data-id="element-199">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-200">
                Mapa de Nutrientes Anti-Inflamatorios
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-201">
                Qué comer (y qué evitar) para reducir la hinchazón.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md border border-[#F5EDE0] flex items-start gap-4" data-id="element-202">
            <CheckCircleIcon className="w-8 h-8 text-[#B8A068] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-203" />
            <div data-id="element-204">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-205">
                Rastreador de 30 Días
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-206">
                Una hoja simple para ver cómo tu dolor disminuye semana tras
                semana.
              </p>
            </div>
          </div>

          <div className="bg-[#F5EDE0] p-6 rounded-xl shadow-md border-2 border-[#B8A068] flex items-start gap-4 md:col-span-2" data-id="element-207">
            <div className="bg-[#B8A068] text-white px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider absolute -mt-10 ml-4" data-id="element-208">
              Bono Especial
            </div>
            <CheckCircleIcon className="w-8 h-8 text-[#B8A068] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-209" />
            <div data-id="element-210">
              <h3 className="font-bold text-[#3D2E1F] text-xl mb-2" data-id="element-211">
                Guía de Calzado Seguro
              </h3>
              <p className="text-[#3D2E1F] opacity-90 text-base md:text-lg" data-id="element-212">
                Cómo proteger tus rodillas desde el suelo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}